import { render, staticRenderFns } from "./admin-create-lead-source-cat.vue?vue&type=template&id=0a473081&scoped=true&"
import script from "./admin-create-lead-source-cat.vue?vue&type=script&lang=js&"
export * from "./admin-create-lead-source-cat.vue?vue&type=script&lang=js&"
import style0 from "./admin-create-lead-source-cat.vue?vue&type=style&index=0&id=0a473081&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a473081",
  null
  
)

export default component.exports